import { keyBy, values } from 'lodash';
import { createSelector } from 'reselect';

export const getCurrentCallList = state => state.search.currentCallList;
export const getLastPageLoaded = state => state.search.lastPageLoaded;
export const getTasks = state => state.search.tasks;
export const hasNextPage = state => state.search.hasNextPage;
export const isFetching = state => state.search.isFetching;

export const getTasksById = createSelector(
  [getTasks],
  tasks => keyBy(tasks, task => task.id)
);

export const sortTasksById = createSelector(
  [getTasksById],
  tasks => values(tasks)
);
